import {
  RecursivePartialSiteAllowStringValues,
  SiteAllowStringValues,
} from "@inrange/building-manager-api-client/models-site";
import { useContextTS } from "@inrange/utils";
import { Col, Form, Row } from "react-bootstrap/";
import { SiteCalculationsContext } from "../../../../../shared-components/src/SiteCalculationsContext";
import CollapsibleCard from "../CollapsibleCard";
import { getCurtailmentDetails } from "./dno-utils";
import { formatNumber, parseAsNumber } from "./utils";

const DnoNetwork = ({
  site,
  setSite,
}: {
  site: SiteAllowStringValues;
  setSite: (site: RecursivePartialSiteAllowStringValues) => void;
}) => {
  const { siteCalculations } = useContextTS(SiteCalculationsContext);
  const [curtailment, curtailmentRisk, curtailmentColor] =
    getCurtailmentDetails(site, siteCalculations);

  return (
    <CollapsibleCard title={"DNO and network"} className="mt-2">
      <Row>
        <Col sm={6}>
          <div style={{ marginTop: "10px" }}>
            <div>
              <strong>DNO name:</strong>{" "}
              {siteCalculations.dno?.name || "Data unavailable"}
            </div>
            <div>
              <strong>DNO average intensity:</strong>{" "}
              {siteCalculations.dno?.annualAverageIntensity || "?"} gram/kWh
            </div>
          </div>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3" controlId="substationData">
            <Form.Label>Substation data</Form.Label>
            <Form.Select
              value={site.tariffConfig.supplier.substationVersion}
              onChange={(e) =>
                setSite({
                  tariffConfig: {
                    supplier: { substationVersion: e.target.value },
                  },
                })
              }
            >
              <option value={"v1"}>V1 - loaded in 2021</option>
              <option value={"v2"}>V2 - loaded in 2025</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <div>
            <strong>DNO operator:</strong>{" "}
            {siteCalculations.substationData?.dno || "Unknown"}
          </div>
          <div>
            <strong>Grid supply point:</strong>{" "}
            {siteCalculations.substationData?.gsp_name || "Unknown"}
          </div>
          <div>
            <strong>Bulk supply point:</strong>{" "}
            {siteCalculations.substationData?.bsp_name || "Unknown"}
          </div>
          <div>
            <strong>Primary substation:</strong>{" "}
            {siteCalculations.substationData?.name || "Unknown"}
            {!!siteCalculations.substationData?.latitude &&
              !!siteCalculations.substationData?.longitude && (
                <span>
                  {" "}
                  (
                  <a
                    href={`https://maps.google.com/?q=${siteCalculations.substationData?.latitude},${siteCalculations.substationData?.longitude}`}
                    rel="noreferrer"
                    target="_blank"
                  >
                    View in Google Maps
                  </a>
                  )
                </span>
              )}
          </div>
          <div>
            <strong>Match type:</strong>{" "}
            {siteCalculations.substationData?.match_type === "polygon"
              ? "Within service area"
              : siteCalculations.substationData?.match_type === "distance"
                ? "Closest substation"
                : "Unknown"}
          </div>
        </Col>
        <Col sm={6}>
          <div>
            Generation headroom:{" "}
            <strong>
              {siteCalculations.substationData?.headroom === undefined
                ? "Headroom not defined"
                : `${formatNumber(Math.round((siteCalculations.substationData?.headroom ?? 0) * 1000), 0, 0)} kVA`}
            </strong>
          </div>
          {curtailment === undefined &&
            parseAsNumber(siteCalculations.totalInstalledCapacity) > 0 && (
              <div>
                Curtailment risk:{" "}
                <strong style={{ color: curtailmentColor }}>
                  {curtailmentRisk}
                </strong>
              </div>
            )}
          <div className="mt-3">
            <strong>Generation headroom scenario</strong>{" "}
          </div>
          <div>
            Name: {siteCalculations.substationData?.scenario_name || "Unknown"}
          </div>
          <div>
            Year: {siteCalculations.substationData?.scenario_year || "Unknown"}
          </div>
          <div>
            Data loaded date:{" "}
            {siteCalculations.substationData?.load_date || "Unknown"}
          </div>
        </Col>
      </Row>
    </CollapsibleCard>
  );
};

export default DnoNetwork;
